module.exports = __webpack_public_path__ + "static/media/addItem.8e06a9aa.svg";